import { useEffect, useState } from 'react';


import request from '../helpers/requests';
import { getData, saveData, saveImage, getImage } from '../helpers/indexedDbHelper';
import { revokeImageUrl } from '../helpers/imageUrls';

const REFRESH_MS = 300000;
const MENU_HASH = '7122121124d0santosaruba42390b0a72ac210dad121';

// useRefresh se usa en ~24 pantallas. Antes cada montaje creaba su propio setInterval y
// nunca lo limpiaba: después de un rato de uso había decenas de intervalos pidiendo lo mismo
// cada 5 minutos, y cada closure mantenía vivo el estado de un componente ya desmontado.
// Ahora hay UN solo intervalo para toda la app y las pantallas se suscriben a los cambios.
const subscribers = new Set();
let intervalId = null;
let running = false;
let version = 0;

const notify = () => {
  version += 1;
  subscribers.forEach((setChange) => setChange(version));
};

const downloadImage = async (url, id, changeimage) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    await saveImage(id, { blob, changeimage });
    // El id no cambia pero el blob sí: hay que soltar la URL vieja.
    revokeImageUrl(id);
  } catch (error) {
    console.log(`Error al descargar la imagen ${id}:`, error);
  }
};

const downloadMenuImages = async (data) => {
  const downloadPromises = [];

  data.data.forEach((item) => {
    const images = [
      ...item.menus.map((menu) => ({
        url: menu.image,
        changeimage: menu.changeimage,
        id: `menu-image-${menu.id}`,
      })),
      ...item.menus.map((menu) => ({
        url: menu.imagehorizontal,
        changeimage: menu.changeimagehorizontal,
        id: `menu-image-h-${menu.id}`,
      })),
    ];

    images.forEach(({ url, id, changeimage }) => {
      if (!url) return;
      const fullUrl = `https://admin.boostmymenu.com/images/menus/${url}`;
      downloadPromises.push(
        (async () => {
          const stored = await getImage(id);
          // Si la imagen no existe todavía, stored es undefined: antes esto lanzaba y se
          // caía el Promise.all completo, así que ninguna imagen nueva se descargaba.
          const storedChange = stored && stored.data ? stored.data.changeimage : null;
          if (!stored || storedChange != changeimage) {
            console.log('Downloading image', fullUrl, id);
            await downloadImage(fullUrl, id, changeimage);
          }
        })()
      );
    });
  });

  await Promise.all(downloadPromises);
};

export const getInitData = async () => {
  // Sin internet una corrida puede quedar colgada; evita que se solapen.
  if (running) return;
  running = true;

  try {
    console.log('veryfing');

    const dataDb = await getData('menu');
    const { data } = await request.get(`/all/menu/web/${MENU_HASH}`);

    if (!dataDb || !dataDb.value) {
      console.log('primera carga del menu');
      await saveData('menu', data);
      await downloadMenuImages(data);
      notify();
      return;
    }

    console.log(data.refresh_app, dataDb.value.refresh_app, 'dataDb.value.refresh_app');
    if (data.refresh_app != dataDb.value.refresh_app) {
      console.log('refresh');
      window.location.reload();
      return;
    }

    if (data.change_menu != dataDb.value.change_menu) {
      console.log('updateing menu');
      await saveData('menu', data);
      await downloadMenuImages(data);
      notify();
    }
  } catch (error) {
    // Típicamente: el iPad se quedó sin internet. No es motivo para romper nada.
    console.log('No se pudo verificar el menú:', error && error.message);
  } finally {
    running = false;
  }
};

export const useRefresh = () => {

  const [change, setChange] = useState(0);

  useEffect(() => {
    subscribers.add(setChange);

    if (!intervalId) {
      intervalId = setInterval(getInitData, REFRESH_MS);
    }

    return () => {
      subscribers.delete(setChange);
      if (subscribers.size === 0 && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);

  return { change, getInitData };


};
